module.exports = __webpack_public_path__ + "img/Pagenotfound_illu.0fd921fa.svg";